import React, { useCallback, useState } from 'react';

import { IScheduleUnitContext, ScheduleUnitContext } from '../../hooks';

const ScheduleUnitProvider: React.FC = ({ children }) => {
  const [unit, setUnit] = useState<IScheduleUnitContext['unit']>(null);

  const selectUnit = useCallback<IScheduleUnitContext['selectUnit']>(
    items => setUnit(items),
    [],
  );

  return (
    <ScheduleUnitContext.Provider
      value={{
        unit,
        selectUnit,
      }}
    >
      {children}
    </ScheduleUnitContext.Provider>
  );
};

export default ScheduleUnitProvider;
